import Cookies from 'js-cookie';
import * as queryString from 'query-string';
import { useEffect } from 'react';

const name = 'mm_signup_utm';
const cookieExpirationInDays = 30;

export const UTMTags = {
  init() {
    const searchValue = window.location?.search;

    if (searchValue) {
      const parsed = queryString.parse(window.location.search);

      const utm = {
        utmSource: parsed['utm_source'],
        utmCampaign: parsed['utm_campaign'],
        utmMedium: parsed['utm_medium'],
      };

      if (Object.values(utm).some(Boolean)) {
        const utmStr = JSON.stringify(utm);

        try {
          localStorage.setItem(name, utmStr);
        } catch {
          console.warn('local storage not supported');
          Cookies.set(name, utmStr, {
            path: '/',
            expires: cookieExpirationInDays,
          });
        }
      }
    }
  },
  get() {
    let val;
    try {
      val = localStorage.getItem(name);
    } catch (err) {
      val = Cookies.get(name);
    }

    return val ? JSON.parse(val) : {};
  },
  clear() {
    try {
      localStorage.removeItem(name);
    } catch (e) {
      Cookies.remove(name, { path: '/' });
    }
  },
};

export const useUtmTags = () => {
  useEffect(() => {
    UTMTags.init();
  }, []);
};
